module.exports = __webpack_public_path__ + "static/media/pear_diamond.b262f485.png";